<template>
  <div>
    <Navbar v-if="this.$route.name == 'bulkmailing'" />
    <Breadcrumb v-if="this.$route.name == 'bulkmailing'" />
    <b-overlay :show="sending" spinner small>
      <template #overlay>
        <div class="text-center">
          <b-spinner small></b-spinner>
          <div>Sending e-mails...{{ sendingNo }}/{{ sendToIds.length }}</div>
        </div>
      </template>
      <div class="col-12 px-4">
        <b-row>
          <b-col class="mb-2">
            Selected <b>{{ sendToIds.length }}</b> consultant<span v-show="sendToIds.length>1">s with unique e-mail</span>
            <span v-show="sendToIds.length>0">
              <br />
                E-mail<span v-show="emailsArray.length>1">s</span>:
                <span v-if="idsArray.length > 10">(showing first 10)<br /></span>
              (<span v-for="(email, index) in emailsArray" :key="index">
                <span v-show="index < 10">{{ email }}, </span>
                <span v-show="index == 9">...</span>
              </span>)
            </span>
          </b-col>
        </b-row>
      </div>
      <div class="col-12 px-4">
        <b-overlay :show="sending" spinner small></b-overlay>
        <b-row>
          <b-col>
            <h4>Mail template</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label for="template_id">Select template</label>
            <b-select
              v-model="template_id"
              :options="templates"
              placeholder="Select template"
              @input="template_get"
            />
          </b-col>
        </b-row>
        <b-row v-show="template_id>0">
          <b-col>
            <label for="mailtype">Mail type</label>
            <b-select
              v-model="mailtype"
              :options="mailtypes"
              placeholder="Select mail type"
            />
          </b-col>
        </b-row>

        <b-row v-show="!sending" class="pt-4 mt-4">
          <b-col class="text-left">
            <b-button
              variant="secondary"
              @click="emitSendingBulkEmail(false)"
            >
              Back to list
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button
              v-if="template_id > 0 && mailtype != ''"
              variant="primary"
              @click="sendmails"
            >
              Send e-mails
            </b-button>
          </b-col>
        </b-row>
        <b-row v-show="template_id>0 && mailtype !=''" class="pt-4">
          <div class="col-12" v-if="user_id==1">
            <b-form-input
              v-model="fromId"
              placeholder="From ID"
              type="text"
              autocomplete="off"
              class="col-2"
            />
          </div>

          <h5 class="pl-3">Preview</h5>
          <div class="col-12"><b>Subject:</b> {{template_subject}}</div>
          <div class="col-12"><b>E-mail body:</b></div>
          <div v-html="template"></div>
        </b-row>
        <b-row v-show="!sending" class="pt-4 mt-4">
          <b-col class="text-left">
            <b-button
              variant="secondary"
              @click="emitSendingBulkEmail(false)"
            >
              Back to list
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button
              v-if="template_id > 0 && mailtype != ''"
              variant="primary"
              @click="sendmails"
            >
              Send e-mails
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-alert class="mt-4 pt-4" v-model="sent" variant="success" dismissible>
        {{ sentmsg}}
      </b-alert>
    </b-overlay>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";

const mailtypes = [
  { value: "newsletter", text: "Newsletter" },
  { value: "general", text: "General" },
  { value: "priority", text: "Priority" },
];

export default {
  name: "BulkMailing",

  components: {
    Navbar,
    Breadcrumb,
  },
  props: {
    idsArray: {
      type: Array,
      required: true,
    },
    emailsArray: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      fromId: 0,
      user_id: this.$store.state.user_id,
      loading: false,
      templates: [],
      template_id: -1,
      template: '',
      template_subject: '',
      first_name: "Susan",
      family_name: "Wheelan",
      email: "gdq@gdq.se",
      mailtype: '',
      mailtypes,
      unsubscribe: 'Click here to unsubscribe',
      sending: false,
      sent: false,
      sentmsg: '',
      sendToIds: [],
      errcount: 0,
      sentcount: 0,
      sendingNo: 0,
    };
  },
  // computed: {
  //   uniqueEmailIdPairs() {
  //     const seen = new Set();
  //     const uniqueEmails = [];
  //     const uniqueIds = [];
  //     this.emailsArray.forEach((email, idx) => {
  //       if (!seen.has(email)) {
  //         seen.add(email);
  //         uniqueEmails.push(email);
  //         uniqueIds.push(this.idsArray[idx]);
  //       } else {
  //         console.warn(`Duplicate email found: ${email}`);
  //       }
  //     });
  //     this.sendToIds = uniqueIds;
  //     return { emails: uniqueEmails, ids: uniqueIds };
  //   }
  // },
  created() {
    this.templates_get();
    const seen = new Set();
    const uniqueEmails = [];
    const uniqueIds = [];
    this.emailsArray.forEach((email, idx) => {
      if (!seen.has(email)) {
        seen.add(email);
        uniqueEmails.push(email);
        uniqueIds.push(this.idsArray[idx]);
      } else {
        console.warn(`Duplicate email found: ${email}`);
      }
    });
    this.sendToIds = uniqueIds;
    // console.log({sendToIds: this.sendToIds, emailsArray: uniqueEmails});
    // this.consultant_get();
  },
  methods: {
    emitSendingBulkEmail(value) {
      this.$emit('stopsendingemail', value);
    },
    templates_get() {
        // Get the list of templates here
        const filter = {
            deleted: {
              operator: '=',
              value: 0,
            }
          }
        this.$store.dispatch('records_readlist', { table_name: 'g_bulkemailtemplates', filter })
        .then((response) => {
            this.templates = response.data.result.map((template) => {
                return {
                    value: template.id,
                    text: template.template_name,
                };
            });
        });
    },
    template_get() {
      console.log('Getting template');
      const selectedTemplateId = this.template_id;
      if (selectedTemplateId != 0) {
        console.log('Here');
        this.$store.dispatch('record_read', { table_name: 'g_bulkemailtemplates', id: selectedTemplateId })
        .then((response) => {
            this.template = response.data.template ?
              response.data.template
                .replaceAll('{{firstName}}', this.first_name)
                .replaceAll('{{familyName}}', this.family_name)
                .replaceAll('{{email}}', this.email)
                .replaceAll('{{unsubscribe}}', this.unsubscribe):
                '';
            this.template_subject = response.data.template ? response.data.template_subject : '';
        });
      } else {
        this.template = '';
        this.template_subject = '';
      }
    },
    async sendmails() {
      this.errcount = 0;
      this.sentcount = 0;
      this.sending = true;
      this.sent = false;
      this.sentmsg = '';
      this.sendingNo = 0;

      const filteredIds = this.sendToIds.filter(id => parseInt(id) >= parseInt(this.fromId));

      this.sendToIds = filteredIds;
      
      for (const id of this.sendToIds) {
        await new Promise(resolve => setTimeout(resolve, 1000));
        try {
          const res = await this.$store.dispatch('bulkmail_send', {
            template_id: this.template_id,
            mailtype: this.mailtype,
            idsArray: [id], // send one at a time
          });
          this.sendingNo++;
          if (res.data && res.data.sentcount > 0) {
            this.sentcount += res.data.sentcount;
          }
          if (res.data && res.data.errcount > 0) {
            this.errcount += res.data.errcount;
          }
        } catch (e) {
          this.errcount++;
        }
      }
      this.sending = false;
      this.sent = true;
      this.sentmsg = `E-mails sent to ${this.sentcount} consultants ${this.errcount > 0 ? `with ${this.errcount} errors` : ''}.`;
      this.template_id = -1;
      this.mailtype = '';
      this.template = '';
      this.template_subject = '';
      this.$emit('emailsSent', { sentcount: this.sentcount, errcount: this.errcount });
    },
  },
};
</script>
<style scoped></style>
